import { render, staticRenderFns } from "./defaultAddress.vue?vue&type=template&id=75766fa2&scoped=true&"
import script from "./defaultAddress.vue?vue&type=script&lang=js&"
export * from "./defaultAddress.vue?vue&type=script&lang=js&"
import style0 from "./defaultAddress.vue?vue&type=style&index=0&id=75766fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75766fa2",
  null
  
)

export default component.exports